import { SelectOption } from '@globaleris/ui.library'
import {
  Contrato,
  EnumCommodity,
  EnumTipoAdhesionCFlotante,
  EnumTipoConceptoFlotante,
  Sujeto
} from '../../api'
import { Concept } from '../../api/Argentia/endpoints/concepts/model/concepts'
import {
  FloatingConceptsDataTableModel,
  FloatingConceptsModel,
  FloatingConceptsModelPatchRequest,
  FloatingConceptsModelPostRequest,
  VirtualBatteryBalanceDetailModel,
  VirtualBatteryBalanceModel
} from '../../api/Argentia/endpoints/floatingConcepts/model/floatingConcepts'
import {
  GenerateInvoiceConceptModel,
  GenerateInvoiceFloatingConceptModel
} from '../../api/Argentia/endpoints/invoices/model/invoices'
import { SettlementGroup } from '../../api/Argentia/endpoints/settlementGroups/model/settlementGroups'
import { EnumTypeSettlementGroup } from '../../api/Argentia/enums/typeSettlementGroup'
import { ContractModel } from '../../api/Argentia/model/contracts'
import { Concepto } from '../../api/oData/model/Concepto'
import { ConceptoFactura } from '../../api/oData/model/ConceptoFactura'
import { ConceptoFacturaDelete } from '../../api/oData/model/ConceptoFacturaDelete'
import { ConceptoFacturaPatch } from '../../api/oData/model/ConceptoFacturaPatch'
import { ConceptoFacturaPost } from '../../api/oData/model/ConceptoFacturaPost'
import { enumKeyToValue, enumTranslateOption } from '../../helpers'
import { formatDateOnlyDate, formatServerDateSpain } from '../../helpers/formatDateOnly'
import FloatingConceptsListItemViewModel, {
  FloatingConceptsConctractViewModel,
  FloatingConceptsFormAddModel,
  FloatingConceptsMasterConceptViewModel,
  FloatingConceptsSubjectViewModel,
  VirtualBatteryBalanceTableModel
} from './floatingConcepts.model'
import { getGlobalActionsConfiguration } from './floatingConcepts.service'
import moment from 'moment'

export const mapFloatingConceptsListFromApi = (
  items: ConceptoFactura[]
): FloatingConceptsListItemViewModel[] => {
  return items && items.map(mapFloatingConceptsFromApi)
}

export const mapFloatingConceptsFromApi = (
  item: ConceptoFactura
): FloatingConceptsListItemViewModel => {
  return (
    item && {
      id: item.idConcepto,
      subject: floatingConceptsSubjectMapperApiToVM(item.contrato?.sujeto),
      contract: floatingConceptsContractMapperApiToVM(item.contrato),
      code: item.codConcepto,
      description: item.concepto,
      initDate: item.fechaInicioConcepto,
      endDate: item.fechaFinConcepto,
      amount: item.importe,
      quantity: item.cantidad,
      unidadMedidaCantidad: item.unidadMedidaCantidad,
      priceUnit: item.priceUnit,
      price: item.precio,
      floatingConceptType: enumKeyToValue(EnumTipoConceptoFlotante, item.tipoConceptoFlotante),
      masterConcept: floatingConceptsMasterConceptMapperApiToVM(item.conceptoMaestro),
      adhesion: enumKeyToValue(EnumTipoAdhesionCFlotante, item.tipoAdhesion),
      actionsConfiguration: getGlobalActionsConfiguration(),
      conceptDetail: item.conceptoDetalle,
      // commodity: item.contrato.commodity
      commodity: enumTranslateOption(
        enumKeyToValue(EnumCommodity, item.contrato.commodity),
        EnumCommodity,
        'enums:EnumCommodity'
      )
    }
  )
}

export const floatingConceptsMapperToAPI_POST = (
  item: FloatingConceptsListItemViewModel
): ConceptoFacturaPost => {
  return (
    item && {
      conceptoMaestro: {
        '@odata.id': 'Conceptos(' + item.masterConcept + ')'
      },
      codConcepto: item.code,
      concepto: item.description,
      fechaInicioConcepto: item.initDate,
      fechaFinConcepto: item.endDate,
      contrato: {
        '@odata.id': 'Contratos(' + item.contract + ')'
      },
      tipoConceptoFlotante: item.floatingConceptType,
      tipoCalculoConcepto: item.tipoCalculoConcepto,
      unidadMedidaCantidad: `${item.unidadMedidaCantidad}`,
      tipoAdhesion: enumKeyToValue(EnumTipoAdhesionCFlotante, item.adhesion),
      cantidad: item.quantity || null,
      precio: item.price || null,
      importe: item.amount || 1,
      conceptoDetalle: item.conceptDetail || item.description
    }
  )
}

export const floatingConceptsMapperToAPI_PATCH = (item: any): ConceptoFacturaPatch => {
  return (
    item && {
      idConcepto: item.id,
      /* conceptoMaestro: {
        '@odata.id': 'Conceptos(' + item.masterConcept?.id + ')'
      }, */
      concepto: item.description,
      fechaInicioConcepto: item.initDate,
      fechaFinConcepto: item.endDate,
      /*  contrato: {
        '@odata.id': 'Contratos(' + item.contract?.id + ')'
      }, */
      /*sujeto: {
        '@odata.id': 'elementoslogisticos(' + item.subject.displayName + ')'
      },*/
      tipoConceptoFlotante: enumKeyToValue(EnumTipoConceptoFlotante, item.floatingConceptType), // enumKeyToValue(EnumTipoConceptoFlotante, item.floatingConceptType),
      tipoAdhesion: enumKeyToValue(EnumTipoAdhesionCFlotante, item.adhesion), //enumKeyToValue(EnumTipoAdhesionCFlotante, item.adhesion),
      cantidad: item.quantity || null,
      precio: item.price || null,
      importe: item.amount,
      conceptoDetalle: item.conceptDetail
    }
  )
}

export const floatingConceptsMapperToAPI_DELETE = (item: any): ConceptoFacturaDelete => {
  return (
    item && {
      idConcepto: item.id
    }
  )
}

export const floatingConceptsSubjectMapperApiToVM = (
  subject: Sujeto | undefined
): FloatingConceptsSubjectViewModel | undefined => {
  return subject && { id: subject.id, displayName: subject.deSujeto }
}

export const floatingConceptsContractMapperApiToVM = (
  contract: Contrato
): FloatingConceptsConctractViewModel => contract && { id: contract.id, code: contract.codContrato }

export const floatingConceptsMasterConceptMapperApiToVM = (
  concept: Concepto
): FloatingConceptsMasterConceptViewModel =>
  concept && { id: concept.idConceptoMaestro, code: concept.codConcepto }

export const contractsMapperToDropDown = (items: Contrato[]): SelectOption[] => {
  return items && items.map(contractMapperToDropDown)
}

export const contractMapperToDropDown = (item: Contrato): SelectOption => {
  return (
    item && {
      value: item.id,
      label: item.codContrato || ''
    }
  )
}

export const subjectsMapperToDropDown = (items: Sujeto[]): SelectOption[] => {
  return items && items.map(subjectMapperToDropDown)
}

export const subjectMapperToDropDown = (item: Sujeto): SelectOption => {
  return (
    item && {
      value: item.id,
      label: item.deSujeto || ''
    }
  )
}

export const baseConceptsMapperToDropDown = (items: Concept[]): SelectOption[] => {
  return (
    items &&
    items
      .sort((n1, n2) => {
        if (n1.code && n2.code && n1.code > n2.code) {
          return 1
        }
        if (n1.code && n2.code && n1.code < n2.code) {
          return -1
        }
        return 0
      })
      .map(baseConceptMapperToDropDown)
  )
}

export const baseConceptMapperToDropDown = (item: Concept): SelectOption => {
  return (
    item && {
      value: item.id,
      label: `${item.code} - ${item.description}` || ''
    }
  )
}

// export const baseConceptsMapperToDropDown = (items: Concepto[]): SelectOption[] => {
//   return (
//     items &&
//     items
//       .sort((n1, n2) => {
//         if (n1.codConcepto && n2.codConcepto && n1.codConcepto > n2.codConcepto) {
//           return 1
//         }
//         if (n1.codConcepto && n2.codConcepto && n1.codConcepto < n2.codConcepto) {
//           return -1
//         }
//         return 0
//       })
//       .map(baseConceptMapperToDropDown)
//   )
// }

// export const baseConceptMapperToDropDown = (item: Concepto): SelectOption => {
//   return (
//     item && {
//       value: item.idConceptoMaestro,
//       label: `${item.codConcepto} - ${item.desConcepto}` || ''
//     }
//   )
// }

export const baseConceptsMapperToFilterOptions = (items: Concepto[]): SelectOption[] => {
  return (
    items &&
    items.map(baseConceptMapperToFilterOption).sort((n1, n2) => {
      if (n1.value > n2.value) {
        return 1
      }
      if (n1.value < n2.value) {
        return -1
      }
      return 0
    })
  )
}

export const baseConceptMapperToFilterOption = (item: Concepto): SelectOption => {
  return (
    item && {
      value: item.codConcepto || '',
      label: `${item.codConcepto} - ${item.desConcepto}` || ''
    }
  )
}

export const mapVBListToTableModel = (
  items: VirtualBatteryBalanceModel[]
): VirtualBatteryBalanceTableModel[] => {
  return items.map(item => mapVBToTableModel(item))
}

export const mapVBToTableModel = (
  item: VirtualBatteryBalanceModel
): VirtualBatteryBalanceTableModel => {
  return {
    ...item,
    codeColumn: item.contractCode ?? item.settlementGroupDescription
  }
}

export const mapFloatingConceptsDataTableToState = (
  floatingConceptsArray: FloatingConceptsDataTableModel[]
): Partial<FloatingConceptsModel>[] => {
  return floatingConceptsArray.map(concept => mapFloatingConceptDataTableToState(concept))
}

export const mapFloatingConceptDataTableToState = (
  floatingConcept: FloatingConceptsDataTableModel
): Partial<FloatingConceptsModel> => {
  return {
    conceptCode: floatingConcept.conceptCode,
    conceptName: floatingConcept.conceptName,
    startDate: formatDateOnlyDate(floatingConcept.startDate),
    endDate: formatDateOnlyDate(floatingConcept.endDate),
    price: floatingConcept.price,
    quantity: floatingConcept.quantity,
    amount: floatingConcept.amount,
    floatingConceptType: floatingConcept.floatingConceptType,
    adhesionType: floatingConcept.adhesionType,
    conceptDetail: floatingConcept.conceptDetail,
    contract: {
      id: floatingConcept.contractId,
      contractCode: floatingConcept.contractCode,
      subjectID: floatingConcept.subjectId,
      subjectDesc: floatingConcept.subjectDesc,
      commodity: floatingConcept.commodity
    } as ContractModel,
    masterConceptId: floatingConcept.masterConceptId,
    settlementGroup: {
      id: floatingConcept.settlementGroupId,
      description: floatingConcept.settlementGroup?.description,
      code: floatingConcept.settlementGroup?.code,
      typeSettlementGroup:
        floatingConcept.settlementGroup?.typeSettlementGroup &&
        enumKeyToValue(
          EnumTypeSettlementGroup,
          floatingConcept.settlementGroup?.typeSettlementGroup
        )
    } as SettlementGroup
  }
}

export const mapFloatingConceptFormDataToPostRequest = (
  formData: FloatingConceptsFormAddModel
): FloatingConceptsModelPostRequest => {
  return {
    conceptCode: formData.conceptCode!,
    conceptName: formData.conceptName!,
    conceptDetail: formData.conceptDetail,
    calculationType: formData.calculationType,
    startDate: moment(formatServerDateSpain(formData.startDate), 'DD-MM-YYYY').format(
      'YYYY-MM-DD'
    )!,
    endDate: moment(formatServerDateSpain(formData.endDate), 'DD-MM-YYYY').format('YYYY-MM-DD')!,
    amount: formData.amount!,
    quantity: formData.quantity,
    price: formData.price,
    floatingConceptType: formData.floatingConceptType,
    unitOfMeasure: formData.unitOfMeasure,
    adhesionType: formData.adhesionType,
    contractId: formData.contractId,
    masterConceptId: formData.masterConceptId,
    settlementGroupId: formData.settlementGroupId
  }
}

export const mapFloatingConceptFormDataToPatchRequest = (
  formData: FloatingConceptsDataTableModel
): FloatingConceptsModelPatchRequest => {
  return {
    conceptId: formData.conceptId!,
    conceptCode: formData.conceptCode!,
    conceptName: formData.conceptName!,
    conceptDetail: formData.conceptDetail,
    startDate: moment(formatServerDateSpain(formData.startDate), 'DD-MM-YYYY').format(
      'YYYY-MM-DD'
    )!,
    endDate: moment(formatServerDateSpain(formData.endDate), 'DD-MM-YYYY').format('YYYY-MM-DD')!,
    amount: formData.amount!,
    quantity: formData.quantity,
    price: formData.price,
    floatingConceptType: formData.floatingConceptType,
    adhesionType: formData.adhesionType,
    settlementGroupId: formData.settlementGroupId
  }
}

export const mapDetailModelArrayToTableModel = (
  responseData: VirtualBatteryBalanceDetailModel[]
): VirtualBatteryBalanceDetailModel[] => {
  return responseData.map(element => mapDetailModelToTableModel(element))
}

export const mapDetailModelToTableModel = (
  element: VirtualBatteryBalanceDetailModel
): VirtualBatteryBalanceDetailModel => {
  return {
    ...element,
    quantity:
      element.adhesionType === EnumTipoAdhesionCFlotante.SaldoLibre ? element.quantity : undefined,
    price: element.adhesionType === EnumTipoAdhesionCFlotante.SaldoLibre ? element.price : undefined
  }
}

export const mapFloatingConceptsToGenerateInvoiceRequest = (
  floatingConcepts: FloatingConceptsDataTableModel[]
): GenerateInvoiceFloatingConceptModel => {
  return {
    contractId: floatingConcepts[0].contractId!,
    concepts: floatingConcepts.map(floatingConcept =>
      mapFloatingConceptsToInvoiceConceptsRequest(floatingConcept)
    )
  }
}

export const mapFloatingConceptsToInvoiceConceptsRequest = (
  floatingConcept: FloatingConceptsDataTableModel
): GenerateInvoiceConceptModel | undefined => {
  if (floatingConcept.conceptId && floatingConcept.startDate) {
    return {
      conceptId: floatingConcept.conceptId,
      startDate: floatingConcept.startDate,
      endDate: floatingConcept.endDate
    }
  }
}
